import { useState } from 'react';
import { Button } from '@xiltrion/ui/button';
import { Icono } from '@xiltrion/ui/icono';
import { Input } from '@xiltrion/ui/input';
import { useCreateTask } from '@/api/hooks';

/** Alta rápida: escribir el título y Enter; queda al final del grupo. */
export function QuickAdd({ projectId, sectionId, patch, label = 'Agregar tarea', className }: { projectId: string; sectionId?: string | null; patch?: Record<string, unknown>; label?: string; className?: string }) {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const create = useCreateTask();
  if (!open) return <Button variant="ghost" size="sm" className={className ?? 'w-full justify-start text-muted-foreground'} onClick={() => setOpen(true)}><Icono nombre="mdi:plus" />{label}</Button>;
  const submit = () => {
    if (!title.trim()) return setOpen(false);
    create.mutate({ projectId, sectionId: sectionId ?? null, title: title.trim(), ...(patch ?? {}) } as never, { onSuccess: () => setTitle('') });
  };
  return (
    <form onSubmit={(e) => { e.preventDefault(); submit(); }} className={className}>
      <Input autoFocus value={title} onChange={(e) => setTitle(e.target.value)} onBlur={() => !title && setOpen(false)} onKeyDown={(e) => e.key === 'Escape' && setOpen(false)} placeholder="Título y Enter" className="h-8 bg-background text-sm" aria-label="Título de la tarea nueva" disabled={create.isPending} />
    </form>
  );
}
